// Multiple instances may open dialogs in the same document.
const locks = new WeakMap();

export function lockScroll(document) {
  let lock = locks.get(document);
  if (!lock) {
    const root = document.documentElement;
    const style = root.style;
    const window = document.defaultView;
    const gutter = window.getComputedStyle(root).getPropertyValue('scrollbar-gutter');
    // Only compensate for an existing viewport scrollbar. Apps scrolling inside
    // their own containers (and overlay scrollbars) need no extra root gutter.
    // Keep host-defined stable gutters, including both-edges, unchanged.
    const properties = ['overflow'];
    if (window.innerWidth > root.clientWidth && !gutter.split(/\s+/).includes('stable')) {
      properties.push('scrollbar-gutter');
    }
    const values = properties.map((name) => ({
      name, value: style.getPropertyValue(name), priority: style.getPropertyPriority(name),
      applied: name === 'overflow' ? 'hidden': 'stable',
    }));
    for (const { name, applied } of values) style.setProperty(name, applied, 'important');
    lock = { style, values, count: 0 };
    locks.set(document, lock);
  }
  lock.count++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--lock.count) return;
    for (const { name, value, priority, applied } of lock.values) {
      // Preserve host changes made while the dialog was open.
      if (lock.style.getPropertyValue(name) !== applied || lock.style.getPropertyPriority(name) !== 'important') continue;
      if (value) lock.style.setProperty(name, value, priority);
      else lock.style.removeProperty(name);
    }
    locks.delete(document);
  };
}
